import { Events, addDataLayerEntry } from '@printdeal/data-layer-manager';

const Actions = {
  click: 'click',
  show: 'show',
};

interface DataProps {
  navType: string;
  eventLabel: string;
  eventActionShow?: boolean;
}

export const dispatchDataLayerEventOnNavigationClick = (data: DataProps) => {
  const { navType, eventLabel, eventActionShow } = data;
  addDataLayerEntry(Events.Event, {
    gaEvent: {
      eventCategory: navType,
      eventAction: eventActionShow ? Actions.show : Actions.click,
      eventLabel,
      eventNonInteraction: true,
    },
  });
  addDataLayerEntry(navType, {
    eventAction: eventActionShow ? Actions.show : Actions.click,
    eventLabel,
    eventNonInteraction: true,
  });
};

export const dispatchDataLayerEventOnNavigationLinkClickGA4 = (eventName: string, title: string) => {
  addDataLayerEntry(eventName, {
    title,
  });
};
